import * as React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 15,
    Width: 200, // Adjust the maximum width as needed
    height:120
  },
}));

export default function CustomizedTooltip({ password }) {
  function conditionCheck(value) {
    if (value == "chracterLength") {
      const regex = /^.{8,20}$/;
      return regex.test(password) ? "green" : "red";
    }
    if (value == "UppercaseLowercase") {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])/;
      return regex.test(password) ? "green" : "red";
    }
    if (value == "SpecialChracter") {
      const regex = /[!@#$%^&*()_+}{"':;?/>.<,|[\]\\\-]/;
      return regex.test(password) ? "green" : "red";
    }
    if (value == "OneNumber") {
      const regex = /\d/;
      return regex.test(password) ? "green" : "red";
    }
    return "red";
  }
  const titleInfo = `
  <div style="display: flex; flex-direction: column;">
  <div style="display: flex; align-items: center;">
      ${conditionCheck("chracterLength") === "green" ? '<span style="color: green;">✔</span>' : '<span style="color: red;">✖</span>'}
      <span style="color: ${conditionCheck("chracterLength")}; margin-left: 8px;">Be 8 to 20 characters long</span>
    </div>
  <div style="display: flex; align-items: center;">
    ${conditionCheck("UppercaseLowercase") === "green" ? '<span style="color: green;">✔</span>' : '<span style="color: red;">✖</span>'}
    <span style="color: ${conditionCheck("UppercaseLowercase")}; margin-left: 8px;">Have at least one uppercase and one lowercase letter</span>
  </div>
  <div style="display: flex; align-items: center;">
    ${conditionCheck("SpecialChracter") === "green" ? '<span style="color: green;">✔</span>' : '<span style="color: red;">✖</span>'}
    <span style="color: ${conditionCheck("SpecialChracter")}; margin-left: 8px;">Have at least one special character</span>
  </div>
  <div style="display: flex; align-items: center;">
    ${conditionCheck("OneNumber") === "green" ? '<span style="color: green;">✔</span>' : '<span style="color: red;">✖</span>'}
    <span style="color: ${conditionCheck("OneNumber")}; margin-left: 8px;">Have at least one number</span>
  </div>
</div>
`;
  return (
    <div>
      <LightTooltip
        title={<div dangerouslySetInnerHTML={{ __html: titleInfo }} arrow />}
      >
        <HelpOutlineIcon />
      </LightTooltip>
    </div>
  );
}
